import { NitroMarkerBase } from "../map/components/NitroMarker";

type LegendRow = {
  label: string;
  pinType:
    | "zipCodes"
    | "customer"
    | "koch"
    | "competitor"
    | "kochAndCompetitor";
};

const legendRows: LegendRow[] = [
  { label: "Zip Code", pinType: "zipCodes" },
  { label: "Customer", pinType: "customer" },
  { label: "Koch", pinType: "koch" },
  { label: "Competitor", pinType: "competitor" },
  { label: "Koch + Competitor", pinType: "kochAndCompetitor" },
];

const MapLegend = () => {
  return (
    <section className="mapLegend" aria-label="Map legend">
      <h3 className="mapLegendTitle">Legend</h3>
      <ul className="mapLegendList" aria-label="Pin type legend list">
        {legendRows.map((row) => (
          <li className="mapLegendRow" key={row.pinType}>
            <span aria-hidden="true" className="mapLegendIcon">
              <NitroMarkerBase height={20} type={row.pinType} width={20} />
            </span>
            <span className="mapLegendLabel">{row.label}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default MapLegend;
